import { Navigate } from 'react-router-dom';
import { getRoleFromToken } from './api'

const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const userRole = getRoleFromToken();

  if (!token) {
    return <Navigate to="/" />;
  }

  // Se a rota exige roles específicas e o usuário não as tem
  if (allowedRoles && !allowedRoles.includes(userRole)) {
    // Redireciona para uma página inicial segura ou exibe "Acesso Negado"
    return <Navigate to="/inicio" />; 
  }

  return children;
};

export default PrivateRoute;